/* Solve problem with sagaStack property of error */
/* ISSUE: https://github.com/redux-saga/redux-saga/issues/934 */
/* TODO: is that still needed? I saw that some commit
referenced to this issue was added */
export default function fixSagaError(error) {
  Object.defineProperty(error, `sagaStack`, {
    writable: true,
    enumerable: false,
    configurable: true,
    value: ``,
  })
  return error
}
